import { Flex } from '@chakra-ui/react';
import CTABox from '@components/interactive/CTABox';
import EmailInput from '@components/interactive/EmailInput';
import { saveNewsletterEmail } from '@components/omniBox/requests';
import Body1 from '@components/typography/Body1';
import Header from '@components/typography/Header';

const CTAWithinPeriod = () => {
  const path = typeof window === 'undefined' ? '' : window!.location.href;
  const localUser = typeof window === 'undefined' ? null : window!.localStorage.getItem('user');

  const handleSubmit = async (email: string) => {
    await saveNewsletterEmail({ email, meta: { path, localUser } });
  };

  return (
    <CTABox>
      <>
        <Header as="h3" color="white">
          Get the Fair Square Bulletin
        </Header>
        <Body1>Medicare savings tips, helpful guides, and more.</Body1>
        <Flex justifyContent="center">
          <EmailInput buttonText="Sign Up" onSubmit={handleSubmit} toastText="Signed up for FSM Newsletter!" />
        </Flex>
      </>
    </CTABox>
  );
};

export default CTAWithinPeriod;
